import {
  FILES_FILTER,
  FILES_FILTER_SUCCESS,
  FILES_FILTER_ERROR,
  FILES_SEGMENTS,
  FILES_SEGMENTS_SUCCESS,
  FILES_SEGMENTS_ERROR,
  FILES_LIST,
  FILES_LIST_SUCCESS,
  FILES_LIST_ERROR,
  FILES_PROCESS_REFRESH,
  FILES_SLIP_QR_UPDATE,
  FILES_DOWNLOAD,
  FILES_SLIP_MKSOFT_DOWNLOAD,
  FILES_INVOICE_ISSUED_MKSOFT_DOWNLOAD,
  FILES_INVOICE_DELIVERED_MKSOFT_DOWNLOAD,
} from "./actionTypes"

export const filesFilter = data => ({
  type: FILES_FILTER,
  payload: data
});

export const filesFilterSuccess = data => ({
  type: FILES_FILTER_SUCCESS,
  payload: {data}
});

export const filesFilterError = error => ({
  type: FILES_FILTER_ERROR,
  payload: error,
});

export const filesSegments = data => ({
  type: FILES_SEGMENTS,
  payload: data
});

export const filesSegmentsSuccess = data => ({
  type: FILES_SEGMENTS_SUCCESS,
  payload: {data}
});

export const filesSegmentsError = error => ({
  type: FILES_SEGMENTS_ERROR,
  payload: error,
});

export const filesList = data => ({
  type: FILES_LIST,
  payload: data
});

export const filesListSuccess = data => ({
  type: FILES_LIST_SUCCESS,
  payload: {data}
});

export const filesListError = error => ({
  type: FILES_LIST_ERROR,
  payload: error,
});

export const filesProcessRefresh = data => ({
  type: FILES_PROCESS_REFRESH,
  payload: data,
});

export const filesSlipQRUpdate = data => ({
  type: FILES_SLIP_QR_UPDATE,
  payload: data,
});

export const filesDownload = data => ({
  type: FILES_DOWNLOAD,
  payload: data
});

export const filesSlipMKSoftDownload = data => ({
  type: FILES_SLIP_MKSOFT_DOWNLOAD,
  payload: data
});

export const filesInvoiceIssuedMKSoftDownload = data => ({
  type: FILES_INVOICE_ISSUED_MKSOFT_DOWNLOAD,
  payload: data
});

export const filesInvoiceDeliveredMKSoftDownload = data => ({
  type: FILES_INVOICE_DELIVERED_MKSOFT_DOWNLOAD,
  payload: data
});
